export interface Genre {
  value: string;
  description: string;
}

export const GENRES: Genre[] = [
  { value: 'Fiction', description: 'Fictional stories and narratives' },
  { value: 'Realistic Fiction', description: 'Realistic stories that could happen in real life' },
  { value: 'Historical Fiction', description: 'Stories set in the past with historical elements' },
  { value: 'Science Fiction', description: 'Futuristic and science-based stories' },
  { value: 'Fantasy', description: 'Stories with magical or supernatural elements' },
  { value: 'Mystery', description: 'Mystery and detective stories' },
  { value: 'Adventure', description: 'Adventure and action stories' },
  { value: 'Horror', description: 'Scary and suspenseful stories' },
  { value: 'Drama', description: 'Dramatic stories with emotional depth' },
  { value: 'Poetry', description: 'Poetic and lyrical content' },
  { value: 'Mythology', description: 'Stories from ancient myths and legends' },
  { value: 'Fable', description: 'Short stories with moral lessons' },
  { value: 'Folktale', description: 'Traditional stories and fables' },
  { value: 'Biography', description: 'Life stories of real people' },
  { value: 'Autobiography', description: 'Personal life stories written by the subject' },
  { value: 'Informational', description: 'Non-fiction informational texts' },
  { value: 'Expository', description: 'Explanatory non-fiction texts' },
  { value: 'Persuasive', description: 'Texts designed to persuade or convince' },
];

// Helper function to get genre by value
export const getGenreByValue = (value: string): Genre | undefined => {
  return GENRES.find(genre => genre.value === value);
};

// Helper function to get all genre values as strings (for backward compatibility)
export const getGenreValues = (): string[] => {
  return GENRES.map(genre => genre.value);
}; 